/**
 * 演示全屏时的键盘控制：Enter 自动播放、Space 停止、方向键翻页
 */
import { useEffect } from 'react';

function isEditingInput(e: KeyboardEvent): boolean {
  const active = document.activeElement;
  return (
    active?.getAttribute('contenteditable') === 'true' ||
    active?.tagName === 'INPUT' ||
    active?.tagName === 'TEXTAREA' ||
    active?.tagName === 'SELECT'
  );
}

export interface UsePresentationKeyboardOptions {
  active: boolean;
  onStartAutoPlay: () => void;
  onStopAutoPlay: () => void;
  onPreviousPage: () => void;
  onNextPage: () => void;
}

export function usePresentationKeyboard({
  active,
  onStartAutoPlay,
  onStopAutoPlay,
  onPreviousPage,
  onNextPage,
}: UsePresentationKeyboardOptions) {
  useEffect(() => {
    if (!active) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (isEditingInput(e)) return;

      if (e.key === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
        onStartAutoPlay();
        return;
      }
      if (e.code === 'Space') {
        e.preventDefault();
        e.stopPropagation();
        onStopAutoPlay();
        return;
      }
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        e.stopPropagation();
        onPreviousPage();
        return;
      }
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        e.stopPropagation();
        onNextPage();
      }
    };
    window.addEventListener('keydown', onKeyDown, true);
    return () => window.removeEventListener('keydown', onKeyDown, true);
  }, [active, onStartAutoPlay, onStopAutoPlay, onPreviousPage, onNextPage]);
}
